const STATUS_CODE = 500

class ApiError500Handler {
  handleError (error) {
    if (error.response.status === STATUS_CODE) {
      console.error(STATUS_CODE)
    }

    return 'Произошла ошибка, попробуйте позже'
  }
}

export default new ApiError500Handler()
